import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    email: yup.string().required('Campo obligatorio'),
  })
  .required()
